import React from 'react';
import { UIDateSlot } from 'types';

interface Props {
	dates: UIDateSlot[];
	times: string[];
	selectedDateSlot?: UIDateSlot;
	setSelectedDateSlot: React.Dispatch<React.SetStateAction<UIDateSlot | undefined>>;
	setSelectedTimeSlot: React.Dispatch<React.SetStateAction<string>>;
}

const DateSlots = ({ selectedDateSlot, setSelectedDateSlot, dates, times, setSelectedTimeSlot }: Props) => {
	const totalSlotsForADate = times.length;
	return (
		<div className="">
			<p className="text-[#111928] text-[14px] font-[500] leading-[21px] font-inter">
				Select a date <span className="text-[red]">*</span>
			</p>

			<div className="mt-[8px] flex gap-[12px] hide-scrollbar w-full overflow-scroll whitespace-nowrap scroll-smooth">
				{dates.map(date => {
					return (
						<div
							key={date.dateText}
							onClick={() => {
								setSelectedDateSlot(date);
								// setSelectedTimeSlot('');
							}}
							className={`${
								selectedDateSlot?.dateText === date.dateText
									? 'border-[2px] border-[#7777E7] bg-[#E5F0FF] text-[#7777E7]'
									: 'border-[2px] border-[#C7C9D9] bg-[#F2F2F5] text-[#1C1C28]'
							} cursor-pointer px-[16px] py-[8px] rounded-[8px] text-center`}
						>
							<p className="font-inter text-[10px] font-[500] leading-[15px] ">{date.dayText}</p>
							<p className="font-inter text-[14px] font-[500] leading-[21px] mt-[1px] ">{date.dateText}</p>
							<p className="font-inter text-[10px] font-[500] leading-[15px] mt-[2px] text-[#05A660]">
								{totalSlotsForADate} slots
							</p>
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default DateSlots;
